import React, { useEffect, useRef } from 'react';
import { FaTimes, FaEnvelope, FaPhone, FaWhatsapp } from 'react-icons/fa';
import { motion } from 'framer-motion';

const ContactModal = ({ isOpen, onClose }) => {
  const modalRef = useRef(null);
  
  // Close the modal when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      // Prevent scrolling when modal is open
      document.body.style.overflow = 'hidden';
    }
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.body.style.overflow = 'unset';
    };
  }, [isOpen, onClose]);

  // Handle escape key press
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };
    
    if (isOpen) {
      document.addEventListener('keydown', handleEscKey);
    }
    
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <motion.div 
        ref={modalRef} 
        className="contact-modal"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        style={{ backgroundColor: '#fff7f1' }}
      >
        <div className="modal-header" style={{ borderBottom: '1px solid rgba(0,0,0,0.05)' }}>
          <h3 style={{ color: '#286278' }}>Contact Us</h3>
          <button className="close-button" onClick={onClose} aria-label="Close">
            <FaTimes />
          </button>
        </div>
        
        <div className="modal-content">
          <p className="modal-description">
            Reach out to us through any of the following channels:
          </p>
          
          <div className="contact-methods">
            <motion.a 
              href="mailto:contact@skillraiz.com" 
              className="contact-method"
              whileHover={{ x: 5, backgroundColor: 'rgba(58, 133, 153, 0.08)' }}
              style={{ backgroundColor: 'rgba(0,0,0,0.02)', border: '1px solid rgba(0,0,0,0.05)' }}
            >
              <div className="contact-icon-wrapper" style={{ background: 'linear-gradient(135deg, #3a8599, #286278)' }}>
                <FaEnvelope className="contact-icon" />
              </div>
              <div className="contact-info">
                <h4>Email</h4>
                <p>contact@skillraiz.com</p>
              </div>
            </motion.a>
            
            <motion.a 
              href="tel:+918106109054" 
              className="contact-method"
              whileHover={{ x: 5, backgroundColor: 'rgba(75, 139, 110, 0.08)' }}
              style={{ backgroundColor: 'rgba(0,0,0,0.02)', border: '1px solid rgba(0,0,0,0.05)' }}
            >
              <div className="contact-icon-wrapper" style={{ background: 'linear-gradient(135deg, #4b8b6e, #376954)' }}>
                <FaPhone className="contact-icon" />
              </div>
              <div className="contact-info">
                <h4>Phone</h4>
                <p>+91 8106109054</p>
              </div>
            </motion.a>
            
            <motion.a 
              href="https://wa.me/918106109054" 
              className="contact-method"
              whileHover={{ x: 5, backgroundColor: 'rgba(193, 122, 144, 0.08)' }}
              style={{ backgroundColor: 'rgba(0,0,0,0.02)', border: '1px solid rgba(0,0,0,0.05)' }}
            >
              <div className="contact-icon-wrapper" style={{ background: 'linear-gradient(135deg, #c17a90, #a45c72)' }}>
                <FaWhatsapp className="contact-icon" />
              </div>
              <div className="contact-info">
                <h4>WhatsApp</h4>
                <p>+91 8106109054</p>
              </div>
            </motion.a>
          </div>
          
          <div className="modal-footer">
            <p className="response-time" style={{ color: '#666' }}>We typically respond within 24 hours</p>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default ContactModal; 